import React, {useEffect} from 'react';
import UseContest from '../../hooks/apis/useContest';
import UseKnowledgeTest from '../../hooks/apis/useKnowledgeTest';
import KnowledgeTestEditForm, {IKnowledgeTestEditForm} from './EditForm';
import moment from 'moment';
import {message, Skeleton} from 'antd';
import CommonApiErrorHandler from '../../utils/HttpInstance';
export default function KnowLedgeTestManage(props: {testId: number}) {
  const queryById = UseKnowledgeTest.queryById();
  const saveTestState = UseKnowledgeTest.save();

  function refresh() {
    queryById
      .request({
        id: props.testId,
      })
      .then()
      .catch(CommonApiErrorHandler);
  }

  useEffect(() => {
    refresh();
  }, [props.testId]);

  function saveTest(form: IKnowledgeTestEditForm) {
    saveTestState
      .request({...form, beginTime: form.beginTime.format(), endTime: form.endTime.format()})
      .then(() => {
        message.success('操作成功');
        refresh();
      })
      .catch(CommonApiErrorHandler);
  }

  return (
    <Skeleton loading={queryById.loading}>
      {queryById.data && (
        <KnowledgeTestEditForm
          form={{...queryById.data, beginTime: moment(queryById.data.beginTime), endTime: moment(queryById.data.endTime)}}
          isLoading={saveTestState.loading}
          onFinish={saveTest}
        />
      )}
    </Skeleton>
  );
}
